module.exports = __webpack_public_path__ + "img/广告投放.8c82af5f.jpg";